import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updatePackage } from "../../api/apiPackages";
import parseError from "../../utils/parseError";

const useUpdatePackage = () => {
    const queryClient = useQueryClient();

    const {
        mutate: editPackage,
        isPending: isUpdate,
    } = useMutation({
        mutationFn: ({ id, req }) => updatePackage(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["packages"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update package");
        },
    });

    return {
        editPackage,
        isUpdate,
    };
};

export default useUpdatePackage;
